import { ActionKeys } from '~/actions/constants';
import { type DialogType } from '~/actions/dialog.actions';
import { type ActionTypes } from '~/actions/index';

export type DialogState = {
  readonly activeDialog: Maybe<DialogType>;
  readonly closeButtonText: Maybe<string>;
  readonly confirmButtonText: Maybe<string>;
  readonly messages: string[];
  readonly title: Maybe<string>;
};

const initialState: DialogState = {
  activeDialog: null,
  closeButtonText: null,
  confirmButtonText: null,
  messages: [],
  title: null,
};

const reducer = (state: DialogState = initialState, action: ActionTypes): DialogState => {
  switch (action.type) {
    case ActionKeys.DIALOG_SHOW:
      return {
        ...state,
        activeDialog: action.payload.dialogType,
        closeButtonText: action.payload.props.closeButtonText,
        confirmButtonText: action.payload.props.confirmButtonText,
        messages: action.payload.props.messages,
        title: action.payload.props.title,
      };
    case ActionKeys.DIALOG_HIDE:
      return {
        ...state,
        activeDialog: null,
        closeButtonText: null,
        confirmButtonText: null,
        messages: [],
        title: null,
      };
    default:
      return state;
  }
};

export default reducer;
